import { render } from "./PhysicalInspection.vue?vue&type=template&id=1e15756a&scoped=true"
import script from "./PhysicalInspection.vue?vue&type=script&lang=js"
export * from "./PhysicalInspection.vue?vue&type=script&lang=js"

import "./PhysicalInspection.vue?vue&type=style&index=0&id=1e15756a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e15756a"]])

export default __exports__